import { render, staticRenderFns } from "./is_need_smt.vue?vue&type=template&id=022ac1d4&scoped=true"
import script from "./is_need_smt.vue?vue&type=script&lang=js"
export * from "./is_need_smt.vue?vue&type=script&lang=js"
import style0 from "./is_need_smt.vue?vue&type=style&index=0&id=022ac1d4&prod&lang=scss&scoped=true"
import style1 from "./is_need_smt.vue?vue&type=style&index=1&id=022ac1d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ac1d4",
  null
  
)

export default component.exports